module.exports = __webpack_public_path__ + "static/media/up.d6dcfc22.svg";